module.exports = __webpack_public_path__ + "img/illustration-teacher.a17b0f08.svg";